import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Wrench, ClipboardCheck, FileText, ExternalLink, AlertTriangle } from 'lucide-react';
import api from '../utils/api';

const MESES = [
  'Ene','Feb','Mar','Abr','May','Jun',
  'Jul','Ago','Sep','Oct','Nov','Dic',
];

function formatFecha(dateStr) {
  if (!dateStr) return '—';
  const d = new Date(String(dateStr).slice(0, 10) + 'T12:00:00');
  return `${d.getDate()} ${MESES[d.getMonth()]} ${d.getFullYear()}`;
}

export default function Historial() {
  const navigate = useNavigate();
  const [formularios, setFormularios] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/formularios')
      .then(res => setFormularios(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const esMant = (f) => f.tipo === 'mantenimiento';

  return (
    <div className="app-container">
      <div className="app-header">
        <button className="back-btn" onClick={() => navigate('/')}>←</button>
        <h1>Historial</h1>
      </div>
      <div className="page-content">
        {loading && <div className="spinner" />}

        {!loading && formularios.length === 0 && (
          <div style={{ textAlign: 'center', padding: '56px 20px' }}>
            <div style={{
              width: 64, height: 64, borderRadius: 18, background: '#161C19',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              margin: '0 auto 16px',
            }}>
              <FileText size={28} color="#4A6058" strokeWidth={1.5} />
            </div>
            <p style={{ fontWeight: 700, fontSize: 15, color: '#F4F7F5', marginBottom: 6 }}>
              Sin formularios aún
            </p>
            <p style={{ color: '#8A9994', fontSize: 13 }}>
              Los formularios enviados aparecerán aquí
            </p>
          </div>
        )}

        {formularios.map(f => (
          <div
            key={f.id}
            onClick={() => navigate(`/formularios/${f.id}`)}
            className="nav-btn"
            style={{
              borderRadius: 14, border: '1px solid rgba(255,255,255,0.07)',
              padding: 14, marginBottom: 10, cursor: 'pointer',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
              {/* Ícono tipo */}
              <div style={{
                width: 40, height: 40, borderRadius: 10, flexShrink: 0,
                background: esMant(f) ? '#12382D' : '#0D1E2E',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                {esMant(f)
                  ? <Wrench size={18} color="#4CAF50" strokeWidth={2} />
                  : <ClipboardCheck size={18} color="#60A5FA" strokeWidth={2} />
                }
              </div>

              {/* Contenido */}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 15, fontWeight: 700, color: '#F4F7F5', marginBottom: 2 }}>
                  {f.label}
                </div>
                <div style={{ fontSize: 13, color: '#8A9994', marginBottom: 6 }}>
                  {f.comunidad}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                  <span style={{
                    background: esMant(f) ? '#12382D' : '#0D1E2E',
                    color: esMant(f) ? '#4CAF50' : '#60A5FA',
                    borderRadius: 6, padding: '2px 8px', fontSize: 11, fontWeight: 700,
                  }}>
                    {esMant(f) ? 'Mantenimiento' : 'Visita técnica'}
                  </span>
                  <span style={{ fontSize: 12, color: '#6B7C74' }}>
                    {formatFecha(f.fecha_visita)}
                  </span>
                  {f.tiene_rai && (
                    <span style={{
                      display: 'flex', alignItems: 'center', gap: 3,
                      background: '#2D0F0F', color: '#EF4444',
                      borderRadius: 6, padding: '2px 7px', fontSize: 11, fontWeight: 700,
                    }}>
                      <AlertTriangle size={10} strokeWidth={2.5} />
                      RAI
                    </span>
                  )}
                </div>
                <div style={{ fontSize: 11, color: '#4A6058', marginTop: 4 }}>
                  {f.folio}
                </div>
              </div>

              {/* Acción Drive (secundaria) */}
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 6, flexShrink: 0 }}>
                {f.pdf_url && (
                  <a
                    href={f.pdf_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={e => e.stopPropagation()}
                    style={{
                      display: 'flex', alignItems: 'center', gap: 4,
                      background: '#0D1E2E', color: '#60A5FA',
                      border: '1px solid rgba(96,165,250,0.2)', borderRadius: 8,
                      padding: '6px 10px', fontSize: 12, fontWeight: 600,
                      textDecoration: 'none', whiteSpace: 'nowrap',
                    }}
                  >
                    <ExternalLink size={12} strokeWidth={2} />
                    Drive
                  </a>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
